/* Ott-common */
import { AuthType } from '@dtvgo/axios-interceptor-auth';

export default function playbackVod(backendAxiosInstance) {
  /**
   * @typedef VodPlaybackParams
   * @type {object}
   * @property {string} assetId
   * @param {string} videoId
   */

  /**
   * @param {VodPlaybackParams} streamParams
   */
  function createVodPlaybackContext(streamParams) {
    return backendAxiosInstance.post(
      '/blim/experience/v1/playback/VOD/context',
      streamParams,
      {
        authType: AuthType.CONSUMER,
      },
    );
  }

  /**
   * @typedef StartVodPlaybackAdditionalParams
   * @type {object}
   * @property {string} streamId
   * @property {number} timelinePosition
   */

  /**
   * @typedef StartVodPlaybackParams
   * @type {VodPlaybackParams & StartVodPlaybackAdditionalParams}
   */

  /**
   * @param {StartVodPlaybackParams} streamParams
   */
  function startVodPlayback(streamParams) {
    return backendAxiosInstance.put(
      '/blim/experience/v1/playback/VOD/start',
      streamParams,
      {
        authType: AuthType.CONSUMER,
      },
    );
  }

  /**
   * @typedef ContinueAndStopVodPlaybackAdditionalParams
   * @type {object}
   * @property {number} assetDuration
   */

  /**
   * @typedef ContinueAndStopVodPlaybackParams
   * @type {StartVodPlaybackParams & ContinueAndStopVodPlaybackAdditionalParams}
   */

  /**
   * @param {ContinueAndStopVodPlaybackParams} streamParams
   */
  function continueVodPlayback(streamParams) {
    return backendAxiosInstance.put(
      '/blim/experience/v1/playback/VOD/continue',
      streamParams,
      {
        authType: AuthType.CONSUMER,
      },
    );
  }

  /**
   * @param {ContinueAndStopVodPlaybackParams} streamParams
   */
  function stopVodPlayback(streamParams) {
    return backendAxiosInstance.put(
      '/blim/experience/v1/playback/VOD/stop',
      streamParams,
      {
        authType: AuthType.CONSUMER,
      },
    );
  }

  /**
   * @param {string} assetId
   */
  function resumeVodPlayBack(assetId) {
    return backendAxiosInstance.get(`/blim/experience/v1/playback/resume/${assetId}`, {
      authType: AuthType.CONSUMER,
    });
  }

  return {
    createVodPlaybackContext,
    startVodPlayback,
    continueVodPlayback,
    stopVodPlayback,
    resumeVodPlayBack,
  };
}
